export default __webpack_public_path__ + "static/media/Flowers07.f0db3815.jpg";